import {useCallback} from 'react'
import {useLocation} from 'react-router-dom'
import {useTrackEvent} from './amplitude.hooks'

/**
 * Returns a `trackFilter(name)` helper that emits the single generic
 * `ProjectFilterApplied` Amplitude event, discriminated by the control used
 * (NOT the selected value), so filter usage can be segmented without leaking
 * business data. The current network sub-path rides along as `screen` so a
 * shared control (sector, viewMode, shift...) can be segmented per tab.
 *
 * Shared by every self-contained header filter. Only user-initiated changes
 * should call it — never self-heal/pruning effects, which are not filter
 * actions.
 */
export const useFilterTracking = () => {
  const trackEvent = useTrackEvent()
  const {pathname} = useLocation()
  const screen = pathname.split('/').pop() ?? ''
  return useCallback(
    (filter: string) => trackEvent('ProjectFilterApplied', {filter, screen}),
    [trackEvent, screen],
  )
}
